// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiRestore } from "@mdi/js";
import {
  INITIAL_SCALE_BY_VALUE,
  scaleByOptions
} from "constants/visualization.constants";

import { ToolbarButton } from "components/base";
import { useXdaSettingsStore } from "components/vis/context";
import { selectResetZuiInstance } from "components/vis/context/xdaSettingsSelectors";

const XdaResetSettings = () => {
  const currentResetZuiInstance = useXdaSettingsStore(selectResetZuiInstance);
  const updateXdaSettings = useXdaSettingsStore((s) => s.updateXdaSettings);

  const handleReset = () => {
    updateXdaSettings({
      scaleByOption: scaleByOptions[0],
      scaleByValue: INITIAL_SCALE_BY_VALUE,
      hangWellsToTop: true,
      widthScaled: 1,
      resetZuiInstance: !currentResetZuiInstance // toggles the useEffect in the XdaViewer to fire and reset the ZUI instance
    });
  };

  return (
    <ToolbarButton
      data-testid="xda-reset-settings"
      icon={<Icon path={mdiRestore} size={1.5} />}
      tooltipText="Reset View"
      overflowLabel="Reset"
      onToggle={handleReset}
      active={false}
      styleKey="xdaToolbar"
    />
  );
};

export default XdaResetSettings;
